export default function RouterPreferenceSettings() {
  // UniswapX is disabled - hide this component
  return null
}
